import * as auth from './auth-const';

// 平台 - 组织和用户
// ============================================================================
// 组织管理
export const org = [auth.P_ORG, auth.P_ORG_VIEW, auth.P_CSM, auth.P_CSA];

// 用户和角色管理
export const user = [auth.P_USER];


// 平台 - 基础信息
// ============================================================================
// 品牌管理
export const brand = [auth.P_BRAND, auth.P_BRAND_AUTH];

// 属性和过滤项管理
export const filter = [auth.P_FILTER];

// 字典管理
export const dict = [auth.P_DICT];

// 关键字管理
export const keyword = [auth.P_KEYWORD];

// 公告管理, 告知管理
export const notice = [auth.P_MSG];

// 客户端配置
export const client = [auth.P_CLIENT];

// 定时任务
export const cron = [auth.P_TASK];


// 平台 - 物料
// ============================================================================
// 物品和材料管理
export const item = [auth.P_ITEM, auth.P_ITEM_PUB];

// 型材产品
export const sectionProduct = [auth.P_SEC_PROD, auth.P_SEC_PROD_PUB];

// 底材管理
export const basicMaterial = [auth.P_ITEM];

// 物料导航
export const matNav = [auth.P_ITEM_NAV, auth.P_SEC_PROD_NAV];


// 平台 - 拼装家具
// ============================================================================
// 零件管理
export const mesh = [auth.P_COMP];

// 模块管理
export const block = [auth.P_BLOCK, auth.P_BLOCK_PUB];

// 家具导航
export const furNav = [auth.P_FUR_NAV];


// 平台 - 素材
// ============================================================================
// 模型, 材质实例, 贴图包管理
export const ue = [auth.P_UEITEM];

// 型材管理
export const sectionBar = [auth.P_SEC_BAR];


// 平台 - 设计方案
// ============================================================================
// 专案管理
export const dpgGroup = [auth.D_DESIGN, auth.D_DESIGN_VA, auth.P_DESIGNER];

// 杂志管理
export const magazine = [auth.P_MAGAZINE];

// 样板间管理
export const blankRoom = [auth.P_ROOM, auth.D_DESIGN_VA];

// 愿望单管理
export const favorite = [auth.P_FAV_ALL, auth.P_FAV_ORG];

// 企业资源定制
export const customResource = [auth.P_OSS];

// 专案导航及专案检索
export const designNav = [auth.P_DESIGN_NAV];


// 平台 - 设计服务
// ============================================================================
// 验收管理
export const inspection = [auth.P_INSPECT, auth.P_INSPECT_DESIGN];

// 方案验收
export const acceptance = [auth.P_ACCEPT];


// 平台 - 财务
// ============================================================================
// 会员/企业激活
export const orgActivate = [auth.P_FD, auth.P_FD_ACTIVE];

// 会员/企业管理
export const orgService = [
  auth.P_FD, auth.P_FD_RENEWAL, auth.P_FD_RENEWAL_VIEW,
  auth.P_FD_UPGRADE, auth.P_FD_DOWNGRADE, auth.P_FD_TERMINAL,
];

// 价格服务管理
export const priceMatrix = [auth.P_FD];

// 财务操作日志
export const financeLog = [auth.P_FD];

// 平台 - 品牌数字门店
// ============================================================================
// 品牌门店
export const brandStore = [auth.P_BRAND_STORE];

// 内容管理
export const brandStoreRes = [auth.P_DIGITAL_RES];


// 平台 - 数字资产
// ============================================================================
// 属性管理
export const assetAttr = [auth.P_DA_ATTR, auth.P_DA_ATTR_PUB];

// 类目管理
export const assetDef = [auth.P_DA_DEF, auth.P_DA_DEF_PUB];

// 资产管理
export const assetProduct = [auth.P_DA, auth.P_DA_VIEW];

// 资产检索
export const assetRetrieve = [auth.P_DA_VIEW];


// 平台 - 官网
// ============================================================================
// 首页管理
export const portalHome = [auth.P_WEBSITE_CONTENT];


// 平台 - 数据治理
// ============================================================================
// 数据迁出
export const migrateOut = [auth.P_MIG_OUT];

// 数据迁出
export const migrateIn = [auth.P_MIG_IN];

// 清理更新
export const updation = [auth.P_CACHE, auth.P_REFRESH, auth.P_THUMB];


// 平台 - 统计与日志
// ============================================================================
// 账号统计
export const accountStats = [auth.P_FD];


// 企业 - 组织和用户
// ============================================================================
// 组织管理
export const DOrg = [auth.D_ORG_INFO];

// 用户和角色管理
export const DUser = [auth.D_USER];


// 企业 - 拼装家具
// ============================================================================
// 模块管理
export const DBlock = [auth.D_BLOCK, auth.D_BLOCK_PUB];


// 企业 - 设计方案
// ============================================================================
// 专案管理
export const DDpgGroup = [auth.D_DESIGN, auth.D_DESIGN_VA, auth.D_DESIGNER];


// 企业 - 设计服务
// ============================================================================
// 验收管理
export const DInspection = [auth.D_INSPECT, auth.D_INSPECT_DESIGN];

// 方案验收
export const DAcceptance = [auth.D_ACCEPT];


// 平台 - 品牌数字门店
// ============================================================================
// 品牌门店
export const DBrandStore = [auth.D_BRAND_STORE];

// 内容管理
export const DBrandStoreRes = [auth.D_DIGITAL_RES];



// 企业 - 数字资产
// ============================================================================
// 类目管理
export const DAssetDef = [auth.D_DA_DEF, auth.D_DA_DEF_PUB];

// 资产管理
export const DAssetProduct = [auth.D_DA, auth.D_DA_VIEW];

// 资产检索
export const DAssetRetrieve = [auth.D_DA_VIEW];
